<template>
  <div>
    <!-- Buton Save pentru Kiosk Colors -->
    <div class="settings-top-bar sticky-header" ref="optionsTopBar">
      <div class="text-right">
        <p class="d-inline-flex">
          <button type="submit" class="btn btn-success btn-icon mar-rt-10 save" @click.prevent="validate" :title="$t('general.saveChanges')">
            <img src="/static/img/icons/save.png">
            {{$t('general.save')}}
          </button>
        </p>
      </div>
    </div>

    <div class="card mar-to-15">
      <div class="card-content">
        <div class="row">
          <div class="col-md-12">
            <p>Qr/Kiosk Colors</p>
            <br>
          </div>
          <div class="col-md-3" v-for="(hex, key) in color" :key="key">
            <div class="form-group" style="max-width: 225px; margin-bottom: 50px;">
              <div style="min-height: 100px;">
                <label>{{ $t(`txtForColors.${key}.title`) }}</label>
                <span style="display: block; font-size: 12px; font-weight: 200; margin-bottom: 20px;">{{ $t(`txtForColors.${key}.msg`) }}</span>
              </div>
              <ChromePicker
                :value="{ hex }"
                @input="updateColor(key, $event)"
              />
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label>Kiosk Pass</label>
              <input type="text" name="appLink" :placeholder="$t('settingCompany.selfOrderDomain')" v-model="model.kiosk_pass" class="form-control">
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label>Text Fiscal Print</label>
              <input type="text" name="appLink" :placeholder="$t('settingCompany.selfOrderDomain')" v-model="model.text_fiscal_print" class="form-control">
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group label-input">
              <label>{{ $t('settingCompany.table_scroll_menu_horizontal') }}</label>
              <p-switch v-model="model.table_scroll_menu_horizontal" type="success"></p-switch>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Chrome } from 'vue-color'
import swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.css'
import PSwitch from 'src/components/UIComponents/Switch.vue'

export default {
  name: 'KioskColorsCard',
  components: {
    ChromePicker: Chrome,
    PSwitch
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      model: this.value,
      color: {
        sideBarBg: '#fff',
        mainPageBg: '#F1F1F1',
        addBtnColor: '#ffca40',
        addBtnColorInv: '#000',
        iconsColor1: '#942007',
        iconsColor2: '#fff',
        secundarColor: '#ffca40',
        principalColor: '#4D966D'
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (newVal) {
        this.model = newVal || {}
        this.model.table_scroll_menu_horizontal = !!this.model.table_scroll_menu_horizontal
        if (this.model.table_colors) {
          try {
            this.color = JSON.parse(this.model.table_colors)
          } catch (e) {
            console.warn('Invalid table_colors JSON, folosim default')
          }
        }
      }
    }
  },
  methods: {
    updateColor (key, newColor) {
      this.color[key] = newColor.hex
      this.model.table_colors = JSON.stringify(this.color)
      this.$emit('input', { ...this.model })
    },
    validate () {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.saveDetails()
        }
      })
    },
    saveDetails () {
      var companyID = this.$session.get('selectedCompany')
      var data = {
        'token': this.$session.get('token'),
        'table_colors': this.model.table_colors,
        'kiosk_pass': this.model.kiosk_pass,
        'text_fiscal_print': this.model.text_fiscal_print,
        'table_scroll_menu_horizontal': this.model.table_scroll_menu_horizontal ? 1 : 0
      }

      var self = this
      this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
        if (response.status === true) {
          swal({'text': self.$t('settingsTips.tipsSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
          self.$session.set('selectedCompanyData', self.buildCompanySessionData(response.data[0]))
        } else {
          swal({'text': self.$t('settingsTips.tipsError'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/KioskColorsCard.vue